import React from "react";
import "../App.css";

/**
 * Bloco central de afirmação institucional (fundo escuro, sem botão).
 * Usado na página Sobre, empilhado antes de um <CTA /> (que já traz um
 * segundo bloco parecido, mas com botão).
 */
export default function Statement({ eyebrow, title, text }) {
  return (
    <section className="statement">
      <div className="statement__blob statement__blob--a" aria-hidden="true" />
      <div className="statement__blob statement__blob--b" aria-hidden="true" />

      <div className="statement__container">
        <span className="statement__quote" aria-hidden="true">“</span>
        {eyebrow && <span className="statement__eyebrow">{eyebrow}</span>}
        <h2 className="statement__title">{title}</h2>
        {text && <p className="statement__text">{text}</p>}
      </div>
    </section>
  );
}
